(function () {
  'use strict';

  /* ─── SCROLL REVEAL ─────────────────────────────────── */
  function initReveal() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.reveal').forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  }

  /* ─── NAV HIDE ON SCROLL ─────────────────────────────── */
  function initNavScroll() {
    var nav = document.getElementById('nav');
    if (!nav) return;
    var lastY = window.scrollY, ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          var y = window.scrollY;
          nav.style.transform = (y > 120 && y > lastY) ? 'translateY(-100%)' : 'translateY(0)';
          lastY = y;
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  /* ─── MOBILE DRAWER ──────────────────────────────────── */
  function initDrawer() {
    var burger = document.getElementById('nav-burger');
    var drawer = document.getElementById('nav-drawer');
    var closeBtn = document.getElementById('nav-close');
    if (!burger || !drawer || !closeBtn) return;

    function openDrawer() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      burger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('no-scroll');
    }
    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      burger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('no-scroll');
    }

    burger.addEventListener('click', openDrawer);
    closeBtn.addEventListener('click', closeDrawer);
    drawer.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', closeDrawer);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });
  }

  /* ─── PRODUCT PAGE GALLERY ───────────────────────────── */
  function initGallery() {
    var mainImg = document.getElementById('main-img');
    if (!mainImg) return;
    document.querySelectorAll('.gallery__thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = this.dataset.src;
        var alt = this.dataset.alt;
        if (!src) return;
        mainImg.src = src;
        if (alt) mainImg.alt = alt;
        document.querySelectorAll('.gallery__thumb').forEach(function (t) {
          t.classList.remove('active');
        });
        this.classList.add('active');
      });
    });
  }

  /* ─── PRODUCT PAGE SIZE + VARIANT SELECTION ─────────── */
  function initVariants() {
    var form = document.getElementById('product-form');
    if (!form) return;

    var variantInput = document.getElementById('variant-id');
    var productJson = document.getElementById('product-json');
    if (!productJson || !variantInput) return;

    var product;
    try { product = JSON.parse(productJson.textContent); } catch (e) { return; }
    var variants = product.variants;

    document.querySelectorAll('.size-chip').forEach(function (chip) {
      chip.addEventListener('click', function () {
        var sizeName = this.dataset.size;
        document.querySelectorAll('.size-chip').forEach(function (c) {
          c.classList.remove('selected');
        });
        this.classList.add('selected');

        var match = variants.find(function (v) {
          return v.options && v.options.some(function (o) {
            return o.toLowerCase() === sizeName.toLowerCase();
          });
        });
        if (match) {
          variantInput.value = match.id;
          var submitBtn = document.getElementById('add-to-cart');
          if (submitBtn) {
            if (!match.available) {
              submitBtn.disabled = true;
              submitBtn.textContent = 'Sold Out';
            } else {
              submitBtn.disabled = false;
              submitBtn.textContent = 'Add to Cart';
            }
          }
        }
      });
    });
  }

  /* ─── CART FORM SUBMIT (AJAX) ────────────────────────── */
  function initCart() {
    var form = document.getElementById('product-form');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var variantId = document.getElementById('variant-id');
      if (!variantId || !variantId.value) {
        showNotice('Please select a size');
        return;
      }
      var btn = document.getElementById('add-to-cart');
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId.value, quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) {
            showNotice(data.description || 'Error — please try again');
            if (btn) { btn.disabled = false; btn.textContent = 'Add to Cart'; }
          } else {
            showNotice('Added to cart');
            updateCartCount();
            setTimeout(function () { window.location.href = '/cart'; }, 800);
          }
        })
        .catch(function () {
          showNotice('Error — please try again');
          if (btn) { btn.disabled = false; btn.textContent = 'Add to Cart'; }
        });
    });
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var el = document.getElementById('cart-count');
        if (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
        }
      });
  }

  function showNotice(msg) {
    var notice = document.getElementById('cart-notice');
    if (!notice) return;
    notice.textContent = msg;
    notice.classList.add('show');
    setTimeout(function () { notice.classList.remove('show'); }, 3000);
  }

  /* ─── INIT ───────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initNavScroll();
    initDrawer();
    initGallery();
    initVariants();
    initCart();
  });
})();
